// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fbdt","index":"styles_index__3KskP"};